var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"pf-c-nav__item"},[_c('a',{class:_vm.cssClasses,attrs:{"href":'/#' + _vm.route}},[_vm._v(" "+_vm._s(_vm.caption)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }